import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { container } from "./NavBar";
import { AiOutlineClose } from "react-icons/ai";
import { AiFillPlayCircle } from "react-icons/ai";
import NoImg from "./NoImg.jpg";
import "../Styles/video.css";
import { ImOpt } from "react-icons/im";
import TrailerTrending from "../Trailers/TrailerTrending";

function Trends() {
  const { toggle } = useContext(container);
  const Api = `https://api.themoviedb.org/3`;
  const TrendsShown = "/trending/all/week";
  const [trendArray, setTrendArray] = useState([]);
  const [trailer, setTrailer] = useState(true);
  const {inputValue} = useContext(container)
  const  input = inputValue
  const shown = input ? "search" : "discover";
  const [trendTittle, setTrendTittle] = useState("");
  const Images = "https://image.tmdb.org/t/p/w500/";


  const Trends = async() => {
    const data = await axios.get(`${Api}${TrendsShown}`, {
      params: {
        api_key: "f14fc28bd5ca473908ddb62bd3f18aff",
        query:input
      },
    });
    const results = data.data.results;
    setTrendArray(results);
  };

  useEffect(() => {
    setTimeout(() => {
      Trends();
    }, 100);
  }, [input]);
  console.log(trendArray);

  const TrendTittle = (trend) => {
    setTrendTittle(trend.title);
    setTrailer(!trailer);
  };

  return (
    <> 
      <div className={toggle ? "mainBgColor" : "secondaryBgColor"}>
        <div className="movies-container">
          {trendArray&&trendArray.length>0&&trendArray.map((trend) => {
            return(
              <>
            <div id={trailer ? "container" : "NoContainer"} key="id">
              <AiFillPlayCircle color="#fff" fontSize={40} id={trailer ? "playIcon" : "hide"} onClick={() => TrendTittle(trend)}/>
              <img src={trend.poster_path ? `${Images}${trend.poster_path}` : NoImg} alt="" onClick={() => TrendTittle(trend)}/>
              <h3 id="smaller-text"  className={toggle ? "mainColor" : "secondaryColor"}>
                {trend?.title?.substr(0,12)}
                </h3>
            </div>
            </>
            )
          })}
          {trailer ? console.log : <TrailerTrending TrendTittle={trendTittle} /> }
            <AiOutlineClose
            id={trailer ? "Nothing" : "Exit1"}
            className={toggle ? "DarkTheme" : "LightThemeClose"}
            fontSize={55}
            color="#fff"
            cursor={"pointer"}
            onClick={() => setTrailer(true)}
          />
        </div>
      </div>
    </>
  );
}

export default Trends;
